import React from "react";
import { TableRow } from "../core/pdf/types";

export interface TableRowState {
	row: TableRow,
}

export const TableRowContext = React.createContext<TableRowState | undefined>(undefined);;

export function useTableRow() {
	return React.useContext(TableRowContext);
}
